import React from "react";
import "./head.css";

const Head = () => {
  return (
    <>
      <section className="head">
        <div className='container flexSB'>
          <div className='left'>
            <div className='logo'>              
              <a href="https://securegate.slt.lk/adminLandingPage">
                <img src='./assets/images/logo.png' alt='Logo' />
              </a>
            </div>
          </div>
          <div className='headingContainer'>
            <h1 className='heading btn-shinenav'>AC & POWER MONITORING CONTROL SYSTEM</h1>
          </div>
          <div className='right flexCenter'>
            <div className='profile flexCenter'>
              {/* Profile section (empty for now) */}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Head;
